import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-updates-page',
    templateUrl: './updates-page.component.html',
    styleUrls: ['./updates-page.component.css'],
    standalone: false,
})
export class UpdatesPageComponent {
    @Input() isMajorUpdate: boolean;
    @Output() onOptionSelected: EventEmitter<boolean> = new EventEmitter();

    handleOptionSelected(option: boolean) {
        this.isMajorUpdate = option;
        this.onOptionSelected.emit(option);
    }
}
